export const fontSizes = {
  xs: '10px',
  sm: '12px',
  md: '14px',
  lg: '16px',
  xl: '18px',
  '2xl': '20px',
  '3xl': '24px',
  '4xl': '28px',
  '5xl': '32px',
  '6xl': '48px',
};

export type FontSizes = keyof typeof fontSizes;
export type FontWeights = '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';
